"use client";

import { Box } from "@mui/material";
import type { SxProps, Theme } from "@mui/material";
import { useState } from "react";
import { actionSx } from "@/src/components/common/broadsheet/tokens";

const CopyCitationButton = ({
  text,
  sx,
}: {
  text: string;
  sx?: SxProps<Theme>;
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(text);
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // clipboard is unavailable; the citation text stays selectable
    }
  };

  return (
    <Box
      component="button"
      type="button"
      onClick={handleCopy}
      aria-label={copied ? "Citation copied" : "Copy citation"}
      className="bf-ui"
      sx={[
        actionSx("outline", "small"),
        { cursor: "pointer", flex: "none" },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {copied ? "Copied" : "Copy"}
    </Box>
  );
};

export default CopyCitationButton;
